import { createFileRoute } from '@tanstack/react-router';

import { bankAccountListScreen, bankAccountListSearch, loadBankAccountMessages, loadBankAccountScreens } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Contas digitais no caminho do menu do legado (`router.tsx:375-394`): `screens.byPath` acha o manifesto e o
// menu vira link interno. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/contas-digitais/contas/')({
  validateSearch: bankAccountListSearch,
  staticData: { screen: bankAccountListScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountListScreen'),
});
